import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./views/components/Header";
import CharaDetail from "./views/chara/CharacterDetail";
import CharaEdit from "./views/chara/CharacterEdit";
import CharaList from "./views/chara/CharacterList";
import ScinarioDetail from "./views/scina/ScinarioDetail";
import ScinarioEdit from "./views/scina/ScinarioEdit";
import ScinarioList from "./views/scina/ScinarioList";
import UserEdit from "./views/pages/UserEdit";
import Mylist from "./views/pages/Mylist";
import Home from "./views/pages/Home";
import Login from "./views/pages/Login";
import CharaCreate from "./views/chara/CharacterCreate";
import ScinarioCreation from "./views/scina/ScinarioCreation";
import VideoCreate from "./views/video/VideoCreate";
import VideoEdit from "./views/video/VideoEdit";
import VideoList from "./views/video/VideoList";
import InfoCreate from "./views/info/InfoCreate";
import InfoEdit from "./views/info/InfoEdit";
import InfoList from "./views/info/InfoList";
import HouseRuleCreate from "./views/houserule/ruleCreate";
import HouseRuleEdit from "./views/houserule/ruleEdit";
import HouseRuleList from "./views/houserule/ruleList";
import AiMemberEdit from "./views/pages/aiMemberEdit";
import NoMatch from "./views/pages/NoMatch";

import { CssBaseline, createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { HelmetProvider } from "react-helmet-async";

function App() {
    const theme = createTheme({
        palette: {
            mode: "dark",
        },
    });

    return (
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <div style={{ marginTop: "64px" }}>
                    <Router>
                        <Header />
                        <Routes>
                            <Route exact path="/" element={<Home />} />
                            <Route path="/:userid/edit" element={<UserEdit />} />
                            <Route path="/mylist" element={<Mylist />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/video-create" element={<VideoCreate />} />
                            <Route path="/video" element={<VideoList />} />
                            <Route path="/video/:videoid" element={<VideoEdit />} />
                            <Route path="/character" element={<CharaList />} />
                            <Route path="/character/:charaid" element={<CharaDetail />} />
                            <Route path="/character/:charaid/edit" element={<CharaEdit />} />
                            <Route path="/scenario" element={<ScinarioList />} />
                            <Route path="/scenario/:scenarioid" element={<ScinarioDetail />} />
                            <Route path="/scenario/:scenarioid/edit" element={<ScinarioEdit />} />
                            <Route path="/character-create" element={<CharaCreate />} />
                            <Route path="/scenario-create" element={<ScinarioCreation />} />
                            <Route path="/info-create" element={<InfoCreate />} />
                            <Route path="/info" element={<InfoList />} />
                            <Route path="/info/:infoid" element={<InfoEdit />} />
                            <Route path="/house-rule-create" element={<HouseRuleCreate />} />
                            <Route path="/house-rule" element={<HouseRuleList />} />
                            <Route path="/house-rule/:houseRuleid/edit" element={<HouseRuleEdit />} />
                            <Route path="/aimember/:aimemberid" element={<AiMemberEdit />} />
                            <Route path="*" element={<NoMatch />} />
                        </Routes>
                    </Router>
                </div>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;
